import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import * as c from '../../constants'
import { BUTTON_OFF } from '../../../../../constants'
import { pushDataLayerSimple } from '../../../../../../../helpers/gtm'
import BusinessIcon from '../../icons/Business'
import FamilyIcon from '../../icons/Family'


class IconField extends PureComponent {
  onIconClick = (e) => {
    e.stopPropagation()
    const { activeHotelType, iconId } = this.props
    const hotelType = (activeHotelType === iconId ? BUTTON_OFF : iconId)
    const { input: { onChange } } = this.props
    this.eventDataPush(hotelType)
    return onChange(hotelType, c.hotelTypeFieldName(iconId))
  }

  eventDataPush = (hotelType) => {
    const { eventTrackingData } = this.props
    switch (hotelType) {
      case c.ICON_BUSINESS:
        pushDataLayerSimple(eventTrackingData.business)
        break
      case c.ICON_FAMILY:
        pushDataLayerSimple(eventTrackingData.family)
        break
    }
  }

  isActive = () => this.props.activeHotelType === this.props.iconId

  activeClass = () => this.isActive() && 'active'

  iconClassName = () => cn('hotel-type-icon-field__icon', this.activeClass())

  getIcon = (id) => {
    const { titles } = this.props
    const iconClassName = this.iconClassName()
    let Icon
    let label

    switch (id) {
      case c.ICON_BUSINESS:
        Icon = <BusinessIcon className={iconClassName} />
        label = titles.business
        break
      case c.ICON_FAMILY:
        Icon = <FamilyIcon className={iconClassName} />
        label = titles.family
        break
      default:
        Icon = <div>?</div>
        label = 'Undefined Icon'
    }

    return (
      <React.Fragment>
        {Icon}
        <div className={cn('hotel-type-icon-field__label', this.activeClass())}>
          {label}
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { iconId, additionalClass } = this.props
    return (
      <button
        type="button"
        className={cn('hotel-type-icon-field', additionalClass, this.activeClass())}
        onClick={this.onIconClick}
      >
        {this.getIcon(iconId)}
      </button>
    )
  }
}


IconField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  iconId: PropTypes.string.isRequired,
  additionalClass: PropTypes.string,
  activeHotelType: PropTypes.string,
  titles: PropTypes.shape({
    business: PropTypes.string,
    family: PropTypes.string,
  }),
  eventTrackingData: PropTypes.arrayOf(String),
}

export default IconField
